import { render, staticRenderFns } from "./Headers.vue?vue&type=template&id=b2c90958&"
import script from "./Headers.vue?vue&type=script&lang=js&"
export * from "./Headers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports